export const arrMatrix1 = [
{
       name: 'Илон',
       icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
       matrix: [
        { val: 0 },
        { val: 0 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 0 },
        { val: 1, icon: 10 },
      ],
    },
    {
      name: 'Егор',
      icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
      matched: true,
      active: false,
      matrix: [
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
      ],
    },
    {
      name: 'Семен',
      icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
      active: false,
      id: 6,
      matrix: [
        { val: 0 },
        { val: 0 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 0 },
      ],
    },

    {
      name: 'Клава',
      icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
      id: 6,
      matrix: [
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 0 },
        { val: 0 },
        { val: 0 },
        { val: 1, icon: 10 },
      ],
    },

    {
      name: 'Толя',
      me: true,
      icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
      author: 6,
      matrix: [
        { val: 1, icon: 10, multiple: -1 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        {
          val: 1,
          icon: 'help',
          question: true,
          answer: null,
          activate: false,
        },
      ],
    },
]
export const arrMatrix2 = [
  {
    name: 'Илон',
    icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
    matrix: [
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 0 },
    ],
  },
  {
    name: 'Егор',
    icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
    matched: true,
    active: false,
    matrix: [
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
  {
    name: 'Семен',
    icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
    active: false,
    id: 6,
    matrix: [
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
    ],
  },

  {
    name: 'Клава',
    icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
    active: false,
    id: 6,
    matrix: [
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
    ],
  },

  {
    name: 'Толя',
    me: true,
    icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
    author: 1,
    matrix: [
      { val: 0 },
      {
        val: 1,
        icon: 'help',
        question: true,
        answer: null,
        activate: false,
      },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
]
export const arrMatrix3 = [
  {
    name: 'Егор',
    icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
    matched: true,
    active: false,
    matrix: [
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
  {
    name: 'Клава',
    icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
    matrix: [
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
    ],
  },
  {
    name: 'Семен',
    icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
    active: false,
    id: 6,
    matrix: [
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
    ],
  },

  {
    name: 'Илон',
    icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
    id: 6,
    matrix: [
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
    ],
  },

  {
    name: 'Толя',
    me: true,
    icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
    author: 2,
    matrix: [
      { val: 1, icon: 10 },
      { val: 0 },
      {
        val: 0,
        icon: 'help',
        question: true,
        answer: null,
        activate: false,
      },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
]


export const arrPopup1 = [
  { text: 'Толя любит приложение "Музыка" за то, что не нужно составлять плейлист, оно само подбирает ему песни. Причём, большинство музыкальных композиций Толе нравится. Но ведь и наш Робот сможет так же, нужно его только научить!\n' },
  { text: 'Один из подходов к определению рекомендаций - найти максимально похожий по музыкальным предпочтениям профиль, по которому и предсказать реакцию на какую-то песню.\n' },
  { text: 'Перед тобой профили разных пользователей, где ты можешь увидеть, какие песни каждому понравились.\n' },
  { text: 'Для начала, найди тот музыкальный профиль, который максимально совпадает с профилем Толи по любимым исполнителям.', buttonTitle: 'Начать' },
]
export const arrPopupChooseUser = [
  { text: 'Ого, у Егора и Толи похожие музыкальные интересы! Теперь осталось сказать, стоит ли рекомендовать Толе песню Юли.', buttonTitle: 'Продолжить' },
]

export const task1 = [
  { text: 'Задание: найди тот музыкальный профиль, который максимально совпадает с профилем Толи.' },
]

export const task2 = [
  { text: 'Задание: теперь скажи, стоит ли рекомендовать Толе песню', key: 'task2' },
]
